import React from "react";

import enquiryChangesModel from "venuescanner-js/react/components/Inbox/models/enquiry-changes";
import {
  NewEnquiry,
  ModifyEnquiry,
  AcceptedEnquiry,
  BookedEnquiry,
  ClosedEnquiry,
  CallFeedback,
  ReopenEnquiry,
  DeclinedEnquiry,
  PaymentEnquiry,
  PaymentRequestEnquiry,
  MarkedBookedEnquiry,
  ExpiredEnquiry,
  RequestToBookEnquiry,
} from "./variants";

import {
  MessageType,
  MessageTypes,
  MessageContent,
} from "venuescanner-js/react/components/Inbox/components/Chat/AutomatedMessage/messageType";

const AutomatedMessage = (props) => {
  const { message, thread, previousOffer, cumulative } = props;
  const { offer } = message;
  const offerStatus = offer ? offer.status : null;
  const autoMessageType = MessageType({
    type: message.type,
    offerStatus,
    previousOffer,
    status: thread.status,
    adminOpen:
      thread._admin_thread_info && thread._admin_thread_info.admin_open,
    viewerRole: thread.viewerRole,
  });
  // console.log({ offerStatus, autoMessageType })
  const Components = {
    [MessageTypes.NEW]: NewEnquiry,
    [MessageTypes.ACCEPTED]: AcceptedEnquiry,
    [MessageTypes.EXPIRED]: ExpiredEnquiry,
    [MessageTypes.BOOKED]: BookedEnquiry,
    [MessageTypes.CLOSED]: ClosedEnquiry,
    [MessageTypes.CALL]: CallFeedback,
    [MessageTypes.MODIFY]: ModifyEnquiry,
    [MessageTypes.REOPEN]: ReopenEnquiry,
    [MessageTypes.DECLINED]: DeclinedEnquiry,
    [MessageTypes.PAYMENT]: PaymentEnquiry,
    [MessageTypes.PAYMENT_REQUEST]: PaymentRequestEnquiry,
    [MessageTypes.REOPEN]: ReopenEnquiry,
    [MessageTypes.REQUEST_TO_BOOK]: RequestToBookEnquiry,
    [MessageTypes.MARKED_BOOKED]: MarkedBookedEnquiry,
  };
  const hide =
    autoMessageType === MessageTypes.MODIFY &&
    enquiryChangesModel({ thread, message })?.length === 0;
  const Component =
    autoMessageType && !hide ? Components[autoMessageType] : null;
  return Component ? (
    <div className="automated-message">
      <Component thread={thread} message={message} cumulative={cumulative}>
        <MessageContent
          messageType={autoMessageType}
          viewerRole={thread.viewerRole}
          message={message}
          thread={thread}
          cumulative={cumulative}
        />
      </Component>
    </div>
  ) : null;
};

export default AutomatedMessage;
